
export function showHideRichText() {
	let type = document.getElementById('contactType');
	let richRow = document.getElementById('richRow');
	let phoneRow = document.getElementById('phoneRow');
	let typeValue = parseInt(type.options[type.selectedIndex].value);

	if (typeValue === 2 || typeValue === 4) richRow.style.display = "";
	else richRow.style.display = "none";
	//phoneRow
	if (typeValue === 1 || typeValue === 2) phoneRow.style.display = "";
	else phoneRow.style.display = "none";
}

export function showContactRichText(form,isnew, multi) {
	const el = document.getElementById('changedType');
	el.value = 'true';
	form.save.disabled = false;
	form.submit();
}
window.showContactRichText = showContactRichText;

let originalCustomer = 0;
let originalOpportunity = 0;
let hasShadowAttributes = false;

function checkChangedLinksWarning() {
	let c = parseInt($('#customerFileAs_PK_').val());
	let o;
	if (Server.mod.opportunity) o = parseInt($('#opportunityName_PK_').val());
	else o = originalOpportunity;

	if (c !== originalCustomer || o !== originalOpportunity) {
		$('#doNotSaveShadows').val('1');
		$('.shadow').css('opacity', '0.3');
		let width = $('#mainForm').width();
		let sw = $('#shadowWarning');
		sw.css('width', (width-8)+'px');
		sw.show();
	} else {
		$('#doNotSaveShadows').val('0');
		$('.shadow').css('opacity', '1');
		$('#shadowWarning').hide();
	}
}

/**
 * @param {string} focusFieldSelector
 * @param {number} customerId
 * @param {number} opportunityId
 * @param {boolean} hasShadow
 */
export function initContactEditing(focusFieldSelector, customerId, opportunityId, hasShadow) {
	showHideRichText();
	originalCustomer = customerId;
	originalOpportunity = opportunityId;
	hasShadowAttributes = hasShadow;
	if (hasShadowAttributes) {
		$('.suggfield').blur(checkChangedLinksWarning);
	}
	$(focusFieldSelector).focus();
}
